"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationBubble = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var alignPoints = [
    { align: "tr tl" },
    { align: "br bl" },
    { align: "tl tr" },
    { align: "tr tr" },
    { align: "br br" },
];
var arrowOffsets = {
    "tr tl": [7, 28],
    "br bl": [7, -28],
    "tl tr": [-7, 28],
    "tr tr": [-76, 28],
    "br br": [-76, -28],
};
var arrowDirections = {
    "tr tr": "right",
    "br br": "right",
};
var alignTo = ".s-dash-item.is-selected";
var ignoreClicksOnByClass = [alignTo]; // do not close on click to the widget
exports.ConfigurationBubble = function (props) {
    var children = props.children, classNames = props.classNames, onClose = props.onClose;
    return (react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: classnames_1.default("bubble-light gd-configuration-bubble s-gd-configuration-bubble", classNames), overlayClassName: "gd-configuration-bubble-wrapper sdk-edit-mode-on", alignTo: alignTo, alignPoints: alignPoints, arrowOffsets: arrowOffsets, arrowDirections: arrowDirections, closeOnOutsideClick: true, closeOnParentScroll: false, ignoreClicksOnByClass: ignoreClicksOnByClass, onClose: onClose }, children));
};
//# sourceMappingURL=ConfigurationBubble.js.map